import { useMutation } from '@tanstack/react-query';
import type { BulkLeftCompanyEmployee } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const mutationFn = (employees: BulkLeftCompanyEmployee[]) => {
  return adminServices.bulkLeftCompanyUpdate(employees);
};

export const useBulkLeftCompanyUpdateMutation = () => {
  return useMutation<unknown, unknown, BulkLeftCompanyEmployee[]>(mutationFn);
};
